import React, { useEffect, useState } from 'react';
import './imageSlider.scss';
import Category from '../category/Category';
import DateText from '../texts/dateText/DateText';
import ReadMore from '../buttons/readMore/ReadMore';
import { useNavigate } from 'react-router-dom';
import { IContent } from '../../tpyes/comment';

interface ImageSliderProps {
  newsData: IContent[];
}

export default function ImageSlider({ newsData }: ImageSliderProps) {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!newsData) {
    return null;
  }

  useEffect(() => {
    const intervalId = setInterval(goNext, 3000);

    return () => clearInterval(intervalId);
  }, [currentIndex]);

  function goPrev() {
    if (currentIndex === 0) {
      setCurrentIndex(newsData.length - 1);
    } else {
      setCurrentIndex(currentIndex - 1);
    }
  }

  function goNext() {
    if (currentIndex === newsData.length - 1) {
      setCurrentIndex(0);
    } else {
      setCurrentIndex(currentIndex + 1);
    }
  }

  return (
    <div>
      <div className="slider-image-container">
        <img src={newsData[currentIndex]?.image} className="slider-image"  onClick={() => navigate(`/news/${newsData[currentIndex].id}`)} />
        <div>
          <div className="slider-dots">
            {newsData.map((data: IContent, index: number) => (
              <div key={index} className={index === currentIndex ? 'active-dot' : 'dot'} onClick={() => setCurrentIndex(index)}></div>
            ))}
          </div>
        </div>

        <div className="left-arrow" onClick={goPrev}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
            <path
              fillRule="evenodd"
              d="M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5Z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <div className="right-arrow" onClick={goNext}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
            <path
              fillRule="evenodd"
              d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      </div>

      <div className="com-main-container">
        <div className="main-category-box">
          <Category value={newsData[currentIndex]?.category?.name ? newsData[currentIndex]?.category?.name : ''} />
        </div>

        <h1 className="slider-title" onClick={() => navigate(`/news/${newsData[currentIndex].id}`)}>
          {newsData[currentIndex].title}
        </h1>
        <p className="detail">{newsData[currentIndex].subtitle}</p>
        <div className="date-box flex">
          <DateText date={newsData[currentIndex].created_at} />
        </div>
        <div className="readMore-box">
          <ReadMore id={+newsData[currentIndex].id} />
        </div>
      </div>
    </div>
  );
}
